/**
 * @description Task types (e.g. STANDARD aka 1040)
 */
export const TASK_TYPES = {
  /** In the DB, this is the 1040 task type. It's the default/standard one. */
  STANDARD: '1040',
  AMENDMENT: 'AMENDMENT',
  PAST_YEAR_RETURN: 'PAST_YEAR_RETURN',
  S_CORP: 'S_CORP',
  PARTNERSHIP: 'PARTNERSHIP',
  CONSULTATION: 'CONSULTATION',
  PAYROLL: 'PAYROLL',
  FOREIGN: 'FOREIGN',
  ESTATE: 'ESTATE',
  OTHER: 'OTHER'
};

/**
 * @description Task types that require an SSN to be provided when creating a task
 */
export const SSN_REQUIRED_TYPES = [TASK_TYPES.STANDARD, TASK_TYPES.AMENDMENT];

/**
 * @description Task list tab names
 */
export const TASK_LIST_TABS = {
  ALL_TASKS: 'ALL_TASKS',
  SUBSTAGE_TASKS: 'SUBSTAGE_TASKS',
  ASSIGNED_TO_ME: 'ASSIGNED_TO_ME'
};
